import { alpha } from '@mui/material/styles';

/**
 * Create interaction states for a color
 * @param color - Base color
 * @returns Object with hover, focus, etc. states
 */
export const createInteractionStates = (color: string) => ({
  hover: alpha(color, 0.1),
  focus: alpha(color, 0.2),
  selected: alpha(color, 0.15),
  disabled: alpha(color, 0.3),
});
